export const FOCUS_STACK_LIGHTBOX_CONTEXT = 'owc-lightbox';

export const LIGHTBOX_EVENTS = {
  close: 'close',
};

export const LIGHTBOX_CLASSES = {
  lockClass: 'locked',
};
